module.exports = __webpack_public_path__ + "img/additionalLogout.4ed79dce.svg";